import React from 'react';
import DateTime from './DateTime';

const monday = DateTime.now().nextMonday();
const tuesday = monday.plus({ day: 1 });
const wednesday = monday.plus({ day: 2 });

const title = 'Annual leave';
const subtitle = 'All day';

const upcoming = [{
  month: monday.toFormat('LLL'),
  day: monday.toFormat('d'),
  title,
  subtitle,
  dayLabel: monday.toFormat('cccc'),
}, {
  month: tuesday.toFormat('LLL'),
  day: tuesday.toFormat('d'),
  title,
  subtitle,
  dayLabel: tuesday.toFormat('cccc'),
}, {
  month: wednesday.toFormat('LLL'),
  day: wednesday.toFormat('d'),
  title,
  subtitle,
  dayLabel: wednesday.toFormat('cccc'),
}];

export default function Upcoming() {
  return (
    <>
      <h2>Upcoming</h2>
      <div>
        {
          upcoming.map((u) => (
            <div className="card leave-upcoming-item" key={`${u.day}${u.month}`}>
              <div className="leave-upcoming-item-date">
                <div className="leave-upcoming-item-month">{u.month.toUpperCase()}</div>
                <div className="leave-upcoming-item-day">{u.day}</div>
              </div>
              <div className="leave-upcoming-item-text">
                <div className="leave-upcoming-item-title">{u.title}</div>
                <div className="leave-upcoming-item-subtitle text-muted">{`${u.dayLabel} - ${u.subtitle}`}</div>
              </div>
            </div>
          ))
        }
      </div>
    </>
  );
}
